module.exports = __webpack_public_path__ + "static/media/6.6b1ef0cc.jpg";